import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CalendarTypeView } from 'primeng/calendar';
import { InputColor } from 'src/app/interfaces/ui.theme';

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
})
export class CalendarComponent {
  @Input() value = '';
  @Input() values: Date[] =[];
  @Input() control!: any;
  @Input() label = '';
  @Input() id = '';
  @Input() color!: InputColor;
  @Input() dense: boolean = false;
  @Input() helperText: string = '';
  @Input() view!: CalendarTypeView;
  @Input() dateFormat: string = 'mm/dd/yyyy';
  @Input() selectionMode: string = 'single';
  @Input() placeholder: string = '';
  @Output() sendClick = new EventEmitter();

  colorClass = {
    error: 'text-error border-error focus:border-red-500',
    success: 'text-green-500 border-green-200 focus:border-green-500',
    warning: 'text-yellow-500 border-yellow-200 focus:border-yellow-500',
  };

  onSelect(event: any) {
    this.sendClick.emit(event);
  }
}
